



















import Vue from 'vue';
import {Component} from 'vue-property-decorator';
import Tabs from '@/components/Tabs.vue';
import clone from '@/lib/clone';
import dayjs from 'dayjs';

@Component({
    components: {Tabs}
})
export default class Statistics extends Vue {

}
